module.exports = __webpack_public_path__ + "img/watch.5bb7a37b.png";